/**
 * _authed — pathless layout route. Все его дети (_authed.today,
 * _authed.segments, ...) рендерятся внутри <AppShell />, после прохождения
 * ProtectedRoute-гарда.
 *
 * URL у детей — без префикса (т.к. _authed это pathless layout):
 *   _authed.today.tsx        → /today
 *   _authed.member.$id.tsx   → /member/:id
 *
 * Поверх контента — плавающий AI-помощник (launcher + slide-over panel),
 * доступный со всех authed-страниц.
 */

import { Fragment } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { ProtectedRoute } from '@/auth/protectedRoute';
import { AiLauncher } from '@/components/ai/AiLauncher';
import { AiPanel } from '@/components/ai/AiPanel';

export const Route = createFileRoute('/_authed')({
  component: () => (
    <ProtectedRoute>
      <Fragment>
        <AppShell />
        <AiLauncher />
        <AiPanel />
      </Fragment>
    </ProtectedRoute>
  ),
});
